import type {ReactElement} from 'react';
import type {TimeZone} from 'timezones-list';
import {Text, TextSize} from '@Components/text';
import {DateTimeSelector} from '@Components/date-time-selector/date-time-selector';
import {getTimeZoneFromTzCode} from '@Libraries/events.library';
import {useComponentAttribute} from '@EmailMakerReact/lib/email-maker-component-style-library';
import {buildDeadlineFromAttributes, dateToWallClock, getDeadlineWallClock, setCountdownDeadline, wallClockToDate} from '@EmailMakerReact/lib/email-maker-countdown-library';
import {COUNTDOWN_ATTRIBUTES} from '@EmailMakerReact/lib/email-maker-countdown-library.types';
import type {EmailMakerControlProps} from '../../right-panel-registry.types';
import {CountdownTimezoneDropdown} from './components/countdown-timezone-dropdown/countdown-timezone-dropdown';
import styles from './countdown-deadline-control.module.scss';

export function CountdownDeadlineControl({component}: EmailMakerControlProps): ReactElement {
  const targetUtc = useComponentAttribute(component, COUNTDOWN_ATTRIBUTES.TARGET_UTC);
  const timezoneCode = useComponentAttribute(component, COUNTDOWN_ATTRIBUTES.TIMEZONE);
  const deadline = buildDeadlineFromAttributes(targetUtc, timezoneCode);
  const wallClock = getDeadlineWallClock(deadline);
  const timezone: TimeZone = getTimeZoneFromTzCode(deadline.timezoneCode);

  function handleDateTimeChange(date: Date): void {
    setCountdownDeadline(component, dateToWallClock(date), deadline.timezoneCode);
  }

  function handleTimezoneChange(selected: TimeZone): void {
    setCountdownDeadline(component, wallClock, selected.tzCode);
  }

  return (
    <div className={styles.wrapper}>
      <Text val={window.i18next.t('pmwjs_counting_down_to')} size={TextSize.MD} className={styles.label} />
      <DateTimeSelector className={styles.dateTime} value={wallClockToDate(wallClock)} minDate={new Date()} onChange={handleDateTimeChange} timeDropdownId="pmw-countdown-time" />
      <div className={styles.timezoneRow}>
        <Text val={window.i18next.t('pmwjs_time_zone')} size={TextSize.SM} className={styles.timezoneLabel} />
        <CountdownTimezoneDropdown selected={timezone} onSelect={handleTimezoneChange} />
      </div>
    </div>
  );
}
